//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Communication Templates */
export const SystemCommunication = {
    /** Gets the template guid for a Assessment Request system communication */
    AssessmentRequest: "41FF4269-7B48-40CD-81D4-C11370A13DED",
    /** Gets the template guid for the Attendance communication */
    AttendanceNotification: "CA794BD8-25C5-46D9-B7C2-AD8190AC27E6",
    /** Gets the template guid for the communication approval email */
    CommunicationApprovalEmail: "11D325F4-DAF3-4579-A9D8-6347CCC02341",
    /** Gets the template guid for  */
    CommunicationQueue: "2FC7D3E3-D85B-4265-8983-970345215DEA",
    /** Gets the template guid for the Exception Notification communication */
    ConfigExceptionNotification: "75CB0A4A-B1C5-4958-ADEB-8621BD231520",
    /** Gets the template guid for the Job Notification communication */
    ConfigJobNotification: "691FEA1B-E5C4-4BF8-A7CD-C588F5C63CA8",
    /** Gets the template guid for digital signature invite */
    DigitalSignatureInvite: "791F2DE4-5A59-60AE-4F2F-FDC3EBC4FFA9",
    /** Gets the template guid for  */
    FinanceExpiringCreditCard: "C07ACD2E-7B9D-400A-810F-BC0EBB9A60DD",
    /** Gets the template guid for  */
    FinanceFailedPayment: "449232B5-9C6B-480E-A881-E317D0BC307E",
    /** Gets the template guid for  */
    FinanceGivingReceipt: "7DBF229E-7DEE-A684-4929-6C37312A0039",
    /** Gets the template guid for finance pledge confirmation communication */
    FinancePledgeConfirmation: "73E8D035-61BB-495A-A87F-39007B98834C",
    /**
     * The financial transaction alert notification summary.
     * Rock.Model.FinancialTransactionAlertType.AlertSummaryNotificationGroupId
     */
    FinancialTransactionAlertNotificationSummary: "FDF323F5-31FA-4F98-9B4C-A8C26A10840E",
    /** Gets the template guid for  */
    FollowingEvent: "CA7576CD-0A10-4ADA-A068-62EE598178F5",
    /** Gets the template guid for  */
    FollowingSuggestion: "8F5A9400-AED2-48A4-B5C8-C9B5D5669F4C",
    /** Gets the template guid for the group attendance digest */
    GroupAttendanceDigest: "345CD403-11D2-4B74-A467-ADD15572DD4F",
    /** Gets the template guid for group attendance reminder */
    GroupAttendanceReminder: "ED567FDE-A3B4-4827-899D-C2740DF3E5DA",
    /** Gets the template guid for  */
    GroupMemberAbsence: "8747131E-3EDA-4FB0-A484-C2D2BE3918BA",
    /** Gets the template guid for  */
    GroupPendingMembers: "18521B26-1C7D-E287-487D-97D176CA4986",
    /** Gets the template guid for  */
    GroupRequirements: "91EA23C3-2E16-2597-4EAF-27C40D3A66D8",
    /** Gets the template guid for  */
    GroupSyncExit: "9AC62F1B-16E0-3886-4CE6-2B9290D6B135",
    /** Gets the template guid for  */
    GroupSyncWelcome: "F66D7DAE-89C1-E8BC-48F8-A0D6B849615F",
    /** Gets the template guid for  */
    KioskInfoUpdate: "BC490DD4-ABBB-7DBA-4A9E-74F07F4B5881",
    /** Gets the template guid for a note approval notification */
    NoteApprovalNotification: "B2E3D75F-681E-430F-82C9-D0D681040FAF",
    /** Gets the template guid for a notewatch notification */
    NoteWatchNotification: "21B92DE2-6825-45F3-BD27-43B47FE490D8",
    /** Gets the template guid for the Prayer Comments Notification */
    PrayerRequestCommentsNotification: "FAEA9DE5-62CE-4EEE-960B-C06103E97AA9",
    /** Gets the template guid for event registration confirmation */
    RegistrationConfirmation: "7B0F4F06-69BD-4CB4-BD04-8DA3779D5259",
    /** Gets the template guid for event registration notification */
    RegistrationNotification: "158607D1-0772-4947-ADD6-EA31AB6ABC2F",
    /** Gets the template guid for Reminder Notifications. */
    ReminderNotification: "7899958C-BC2F-499E-A5CC-11DE1EF8DF20",
    /** The scheduling confirmation communication */
    SchedulingConfirmation: "F8E4CE07-68F5-4169-A865-ECE915CF421C",
    /** The scheduling reminder communication */
    SchedulingReminder: "8A20FE79-B73C-447A-82B1-416F9B50C038",
    /** The scheduling response communication */
    SchedulingResponse: "D095F78D-A5CF-4EF6-A038-C7B07E250611",
    /** Gets the template guid for the Account Created communication */
    SecurityAccountCreated: "84e373e9-3aaf-4a31-b3fb-a8e3f0666710",
    /** Gets the template guid for the Confirm Account communication */
    SecurityConfirmAccount: "17aaceef-15ca-4c30-9a3a-11e6cf7e6411",
    /** Gets the template guid for Confirm Account (Passwordless) communication */
    SecurityConfirmAccountPasswordless: "543B7C09-80C0-4DAB-8487-10569474D9C7",
    /** Gets the template guid for Passwordless Login Confirmation communication */
    SecurityConfirmLoginPasswordless: "A7AD9FD5-A343-4ADA-868D-A3528D650143",
    /** Gets the template guid for the Forgot Username communication */
    SecurityForgotUsername: "113593ff-620e-4870-86b1-7a0ec0409208",
    /** Gets the template guid for Sign-Up Group Registration Confirmations. */
    SignupGroupRegistrationConfirmation: "B546C11D-6C92-400F-BA56-AAA22D7BAC01",
    /** Gets the template guid for Sign-Up Group Reminders. */
    SignupGroupReminder: "530ADF1E-C2D9-4A67-BADF-5EF65222CA7E",
    /** Gets the template guid for a Spark Data notification */
    SparkDataNotification: "CBCBE0F0-67FB-6393-4D9C-592C839A2E54",
    /** Gets the template guid for the system Electronic Signature Receipt */
    SystemElectronicSignatureReceipt: "224A0E80-069B-463C-8187-E13682F8A550",
    /** Gets the template guid for workflow form notifications */
    WorkflowFormNotification: "88C7D1CC-3478-4562-A301-AE7D4D7FFF6D",
};
